import { Injectable } from '@angular/core';
import { SpmApi } from 'src/app/api/observations/spm.api';
import { DateTimeDTO } from 'src/app/model/date-time-dto.model';
import { CreateObservationDTO } from 'src/app/model/observation/diff/diff-create-dto.model';
import { PerformanceMasterDTO } from 'src/app/model/observation/spm/performance-master-dto.model';

@Injectable({
    providedIn: 'root'
})
export class SpmService {

    constructor(private spmApi: SpmApi) { }

    getObservationDetails = (spmId: string) =>
        this.spmApi.getObservationDetails(spmId);

    createSpm = (createDto: CreateObservationDTO) =>
        this.spmApi.createSpm(createDto);

    scheduleInitialConference = (spmId: string, date: DateTimeDTO) =>
        this.spmApi.scheduleInitialConference(spmId, date);

    completeInitialConference = (spmId: string, complete: boolean) =>
        this.spmApi.completeInitialConference(spmId, complete);


    savePerformanceMaster = (performanceMaster: PerformanceMasterDTO) =>
        this.spmApi.savePerformanceMaster(performanceMaster);

    submitPerformanceMaster = (performanceMaster: PerformanceMasterDTO, section: number) =>
        this.spmApi.submitPerformanceMaster(performanceMaster, section);

    linkSignature = (observationId: string, section: number) =>
        this.spmApi.linkSignature(observationId, section);

    saveFinalRating = (observationId: string, rating: number) =>
        this.spmApi.saveFinalRating(observationId, rating);

    notifyOfComment = (observationId: string) =>
        this.spmApi.notifyOfComment(observationId);
}
